import { combineReducers } from 'redux'

import { default as positions } from './positions'
import locationDepartments from './locationDepartment'
import categories from './categories'
import groups from './groups'
import features from './features'

export default combineReducers({
  positions,
  locationDepartments,
  categories,
  groups,
  features
})



// WEBPACK FOOTER //
// ./src/modules/Positions/reducers/index.js